import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'store/store'
import { CommercialSection } from './components/CommercialSection'
import { BillingSection } from './components/BillingSection'
import { TrackingSection } from './components/TrackingSection'
import { PartnersSection } from './components/PartnersSection'
import { CancelSection } from './components/CancelSection'

import * as S from './styles'
import { getDetailedInfo } from 'store/OVContext/ovSlice'

const GeneralInfoTab = () => {
  const dispatch = useDispatch()
  const { ovNumber } = useParams()
  const {
    ovSelected: { statusOrdemVenda: status }
  } = useSelector((state) => state.ov)
  const isCanceled = status?.split('-')[0] === '90'

  useEffect(() => {
    dispatch(getDetailedInfo(ovNumber ?? ''))
  }, [ovNumber])

  return (
    <S.Wrapper>
      <div className="commercial">
        <CommercialSection />
      </div>
      <BillingSection />
      <TrackingSection />
      {isCanceled ? (
        <>
          <div className="partners">
            <PartnersSection />
          </div>
          <div className="cancel">
            <CancelSection />
          </div>
        </>
      ) : (
        <div className="fullWidth">
          <PartnersSection />
        </div>
      )}
    </S.Wrapper>
  )
}

export default GeneralInfoTab
